import React from 'react';
import { RouteDetailsTableProps } from '../../../../../sp-types/routeDetailsType';

export const RouteDetailsTable: React.FC<RouteDetailsTableProps> = ({ columns, rowsData }) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 border ">
        <thead className="bg-gray-50">
          <tr>
            {columns.map((column, index) => (
              <th key={index} className="text-left text-xs p-2 ">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {rowsData.map((row, rowIndex) => (
            <tr key={rowIndex} className="">
              {Object.entries(row).map(([key, value], cellIndex) => (
                <td key={cellIndex + key} className="text-sm whitespace-nowrap p-2 border">
                  {value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
